import Product from './product.js'
import DateUtils from "../utils/date.js"
import StringUtils from "../utils/string.js"

class ProductThumbnail extends Product {

  constructor($product, settings) {
    super($product, settings)
    
    this.$optionsContainer.find('select').change(event => {
      this.syncThumbnail()
    })
    
    this.$links.click(this.on.bind(this, 'follow_link'))
    
    this.$secondaryBuyButtons.click(event => {
      this.syncThumbnail($(event.delegateTarget).data('idartref')).then(() => 
        this.on('add_to_cart')
      )
    })
    
    this.$unavailabilityButton.click(this.stockRecoverAlert.bind(this))
  }
  
  syncThumbnail(idArtRef) {
    if (idArtRef !== undefined) {
      this.$optionsContainer.find('select').val(this.$optionsContainer.find(`select option[data-idartref="${idArtRef}"]`).attr('value'))
    }
    return this.load().then(() => {
      this.on('reference_change')
      this.currentReference = this.configuredReference
    })
  }

  // Reference setters and getters
  set currentReference(reference) {
    if (reference !== undefined) {
      try {
        this.$productPageLinks.attr('href', reference.link.replace(/^.+:\/\/[^/]+\//i, ''))
        this.$productPageLinks.attr('rel', 'nofollow')
        if (reference.pictures && reference.pictures.length > 0) {
          this.pictures = reference.pictures
        } else {
          this.pictures = this.data.articles[reference.idArt].pictures
        }
        this.price = reference.price

        let smallLabels = this.data.articles[reference.idArt].labels.filter( labelId => this.data.labels[labelId].picture.small !== null )
        this.labels = this.data.articles[reference.idArt].mainLabel !== null
          && this.data.labels[this.data.articles[reference.idArt].mainLabel].picture.small !== null
          ? [ this.data.articles[reference.idArt].mainLabel ]
          : ( smallLabels.length > 0
            ? [ smallLabels[0] ]
            : [] )
        
        if (reference.quantityInPack > 1) {
          this.packedQuantity = reference.quantityInPack
        }
        
        this.merchantInfos = reference.merchantId
        this.state = reference.state
      } catch (error) {
        throw {
          in: 'Thumbnail :: set currentReference',
          error: { message: error.message, stack: error.stack },
          dataType: typeof this.data,
          _dataType: typeof this._data,
          data: this.data,
          reference: reference
        }
      }
    }
  }

  set pictures(pictures) {
    const $option = this.$optionsContainer.find('select option:selected')
    let option = ''
    if ($option.data('idartref')) {
      option = StringUtils.trim($option.text())
    }
    const altTemplate = i =>`${StringUtils.trim(this.$brandLabel.text())} - ${StringUtils.trim(this.$title.text())}${option}${i === '' ? '' : ` (${i})` }`
    if (pictures !== null && pictures.length > 0) {
      this.$mainPicture
        .attr("src", pictures[0].medium)
        .attr('alt', altTemplate(''))
        .data('large', pictures[0].large)
    } else {
      this.$mainPicture
        .attr("src", 'images/interface/produit/nopic.jpg')
        .attr('alt', 'Aucun visuel disponible')
    }
  }

  get rubId() {
    return this.$container.data('rubid')
  }

  get quantity() {
    return 1
  }

  set labels(labels) {
    this.$labelsList.find('> img').remove()
    this.$labelsList.append(labels
      .filter(labelId => this.data.labels[labelId].visibility.thumbnail)
      .map(labelId =>
        $('<img/>', {
          src: this.data.labels[labelId].picture.small,
          title: this.data.labels[labelId].name
        })
    ))
  }

  set packedQuantity(q) {
    this.$labelsList.find('> div').remove()
    this.$labelsList.prepend($('<div/>').text(`X${q}`))
  }

  // Object general getters and setters
  set price(price) {
    this.$priceContainer
      .html(StringUtils.toLocaleString(price.final, {style: "currency", currency:  price.devise}))

    if (price.final !== price.original) {
      this.$priceContainer.append($('<span>', { class: 'stroke' }).html(StringUtils.toLocaleString(price.original, {style: "currency", currency: price.devise})))
    }
    
    if (price.ecotaxe) {
      $('<span>', {class: 'ecotaxe'})
              .html(`Dont participation écotaxe de ${StringUtils.toLocaleString(price.ecotaxe, {style: "currency", currency: price.devise})}`)
              .appendTo(this.$priceContainer)
    }

    if (price.offerType !== null) {
      this.$offerType.html(price.offerType === 'PROMO' && price.offer !== null ? price.offer : price.offerType ).closest('.corner').show()
    } else {
      this.$offerType.closest('.corner').hide()
    }

  }

  set state(state) {
    this.$unavailabilityListButton.addClass('hidden')
    this.$linkToProductButton.addClass('hidden')
    
    if (state.unavailability !== null) {
      
        if (state.unavailability.neverAgain || state.forSell) {
          this.$unavailabilityButton.toggleClass('hidden', true)
          this.$buyButton.toggleClass('hidden', false)
          
        } else {
          this.$unavailabilityButton.html(state.unavailability.message).toggleClass('hidden', false)
          this.$buyButton.toggleClass('hidden', true)
        }
        
    } else {
      this.$buyButton.toggleClass('hidden', false)
      this.$unavailabilityButton.toggleClass('hidden', true)
    }

    this.$buyButton.toggleClass('disabled', ! state.forSell)
    this.$priceContainer.css({visibility: ! state.forSell && state.neverAgain ? 'hidden' : 'visible'})
  }

  get configuredReference() {
    if (this.data === undefined) {
      return {
        idArt: this.$container.data('idart'),
        idArtRef: this.$container.data('idartref'),
        merchantId: this.$container.data('merchantid')
      }
    } else {
      let $optionSelected = this.$optionsContainer.find('select option:selected')
      if ($optionSelected.length > 0) {
        return this.data.references[$optionSelected.data('idartref')]
      } else {
        return this.data.references[this.$container.data('idartref')]
      }
    }
    return undefined
  }
  
  set merchantInfos(merchantId) {
    // Update merchant infos
    if (merchantId === undefined || merchantId === null || !(merchantId in this.data.merchants)) {
      this.$merchantsContent.parent().slideUp()
    } else {
      this.$merchantsContent.parent().slideDown()
      
      let merchant = this.data.merchants[merchantId]

      if (merchant.label !== null
              && merchant.label !== '') {
        if (merchant.link !== null) {
          this.merchantLabel = $('<a/>', {
            href: merchant.link
          }).html(`Vendu par <span>${merchant.label}</span>`)
        } else {
          this.merchantLabel = `Vendu par <span>${merchant.label}</span>`
        }
      }

      if (merchant.shipping !== null) {
        let merchantArguments =
          (merchant.shipping.lowPrice !== null || merchant.shipping.delay
            ? [`Envoi ${merchant.shipping.lowPrice === null
                ? ''
                : `à partir de ${StringUtils.toLocaleString(merchant.shipping.lowPrice, {style: "currency", currency: merchant.shipping.devise})},`}  ${merchant.shipping.delay !== null
                  ? DateUtils.getDelayRangeStr(merchant.shipping.delay.minDays, merchant.shipping.delay.maxDays)
                  : ''}`
              ]
            : [])
        if (merchant.args !== null) {
          merchantArguments = merchantArguments.concat(merchant.args)
        }

        if (merchant.shipping.offers !== null) {
          merchantArguments = merchantArguments.concat(merchant.shipping.offers)
        }

        this.merchantArguments = merchantArguments
      }
    }
  }
}

// Define custom lazy load properties
let _uiSelectors = {
  quantityContent:            '.quantity .content',
  optionsContainer:           '.titre h4',
  buyButton:                  'button.add-to-cart.thumb-main',
  secondaryBuyButtons:        'button.add-to-cart:not(.thumb-main)',
  unavailabilityButton:       '.button.availability:not(.availability-list):not(.disabled)',
  unavailabilityListButton:   '.button.availability-list',
  linkToProductButton:        'a.link-to-product',
  links:                      '[href]',
  addToBirthListButton:       '.birth-list a.add-to-birth-list',
  mainPicture:                '.image img',
  productPageLinks:           '.image a, .titre a, .avis a',
  priceContainer:             '.price',
  quantityInCart:             'button.add-to-cart .qty',
  stockContainer:             '.stock',
  merchantLabel:              '.vendeur',
  offerContainer:             '.offer',
  descriptionContent:         '.description .content',
  utilisationContent:         '.utilisation .content',
  securityContent:            '.security .content',
  compositionContent:         '.composition .content',
  brandLabel:                 '.brand',
  brandContent:               '.brand .content',
  reviewsContent:             '.reviews .content',
  shortDescriptionContent:    '.short-description',
  title:                      '.titre h3 a',
  productNotationContainer:   '.product-notation',
  merchantInfosList:          '.merchant-infos ul',
  merchantsContent:           '.merchants .content',
  labelsList:                 '.label',
  folders:                    '.body.foldered',
  offerType:                  '.corner span',
  optionsSummary:             '.options-summary',
  head:                       '> .head',
  unavailability:             '.dispo'
}

function _getCachedUIPropertyName(selectorName) {
  return `_$${selectorName}`
}

function _getUIPropertyName(selectorName) {
  return `$${selectorName}`
}

for (let elementSelectorName in _uiSelectors) {
  let propertyName = _getUIPropertyName(elementSelectorName)
  Object.defineProperty(ProductThumbnail.prototype, propertyName, {
    get: function () {
      let field = _getCachedUIPropertyName(elementSelectorName)
      return this[field] !== undefined
        ?  this[field]
        : this[field] = this.$container.find(_uiSelectors[elementSelectorName])
    }
  })
}

export default ProductThumbnail
